import React, { createContext, useContext, useState } from 'react';

import { Answers } from '../types';
import { AppStep, Step } from '../types/enums';

interface Props {
  children: React.ReactNode;
}

interface CheckListContextType {
  answers: Answers;
  setAnswerByStep: (step: Step, answer: string) => void;
  currentStep: Step;
  setCurrentStep: React.Dispatch<React.SetStateAction<Step>>;
  appStep: AppStep;
  setAppStep: React.Dispatch<React.SetStateAction<AppStep>>;
}

export const CheckListContext = createContext<CheckListContextType | null>(
  null
);

export const useCheckListContext = () => {
  const context = useContext(CheckListContext);
  if (!context) {
    throw new Error('Missing provider for CheckListContext');
  }

  return context;
};

const CheckListProvider = ({ children }: Props) => {
  const defaultAnswers = {
    [Step.FAUCET]: '',
    [Step.WATER_HEATER]: '',
    [Step.WATER_WASTEWATER]: '',
    [Step.DRAINS]: '',
    [Step.SMOKE_DETECTORS]: '',
    [Step.FIRE_EQUIPMENT]: '',
    [Step.KITCHEN_FAN]: ''
  };
  const [answers, setAnswers] = useState<Answers>(defaultAnswers);
  const [currentStep, setCurrentStep] = useState<Step>(Step.FAUCET);
  const [appStep, setAppStep] = useState<AppStep>(AppStep.START);

  const setAnswerByStep = (step: Step, answer: string) => {
    setAnswers((prevState) => ({ ...prevState, [step]: answer }));
  };

  return (
    <CheckListContext.Provider
      value={{
        answers,
        setAnswerByStep,
        currentStep,
        setCurrentStep,
        appStep,
        setAppStep
      }}
    >
      {children}
    </CheckListContext.Provider>
  );
};

export default CheckListProvider;
